var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconImgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_img_delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_300",
    "data-name": "\\uD0C0\\uC6D0 300",
    cx: 10,
    cy: 10,
    r: 10,
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8197",
    "data-name": "\\uADF8\\uB8F9 8197",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4039",
    "data-name": "\\uC0AC\\uAC01\\uD615 4039",
    width: 1.5,
    height: 11,
    rx: 0.75,
    transform: "translate(1 2.061) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4040",
    "data-name": "\\uC0AC\\uAC01\\uD615 4040",
    width: 1.5,
    height: 11,
    rx: 0.75,
    transform: "translate(2.061 9.839) rotate(-135)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImgDelete);
export default __webpack_public_path__ + "static/media/icon_img_delete.22919c5fac0ac195454c9a92dd614328.svg";
export { ForwardRef as ReactComponent };